export { default } from "./BaseSwitch.vue";
